/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins, variables } from '@blend/consumer-components';

import { BlIconType } from '@blend/shared-react';
import { zIndex } from '@blend/consumer-components';
import poweredByGoogle from './powered_by_google_on_white.png';
import AddressDropdownElement from './AddressDropdownElement';
import { FormattedAddress } from './addressDropdownTypes';

export interface AddressDropdownProps {
  searchText: string;
  addressList: FormattedAddress[];
  selectedAddressIndex: number;
  icon: BlIconType;
  onSelect: (selectedAddressIndex: number) => void;
  showAPICredit: boolean;
}

const bgColor = colors.white;
const addressDropdownStyle = StyleSheet.create({
  base: {
    backgroundColor: bgColor,
    boxShadow: mixins.boxShadow(0, 4, 4, 0, mixins.rgba(0, 0, 0, 0.15)),
    borderRadius: variables.globalBorderRadius,
    position: 'absolute',
    width: '100%',
    zIndex: zIndex.dynamicSelector,
    ...mixins.border(1, 'solid', colors.clayMinus1),
  },
  listContainer: {
    padding: 0,
    margin: 0,
    zIndex: zIndex.dynamicSelector,
  },
  apiCreditImg: {
    margin: '0 auto',
    display: 'block',
  },
  imageWrapper: {
    padding: 8,
    ...mixins.borderTop(1, 'solid', colors.gray),
  },
});

class AddressDropdown extends Component<AddressDropdownProps> {
  render() {
    const { showAPICredit, icon, addressList, selectedAddressIndex, onSelect, searchText } = this.props;
    return (
      <div data-it="AddressDropdown" className={css(addressDropdownStyle.base)}>
        <ul className={css(addressDropdownStyle.listContainer)}>
          {addressList.map((address, i) => (
            <AddressDropdownElement
              onSelect={() => onSelect(i)}
              key={i}
              searchText={searchText}
              {...address}
              highlighted={i === selectedAddressIndex}
              icon={icon}
            />
          ))}
        </ul>
        {showAPICredit && (
          <div className={css(addressDropdownStyle.imageWrapper)}>
            <img className={css(addressDropdownStyle.apiCreditImg)} src={poweredByGoogle} alt="Powered By Google" />
          </div>
        )}
      </div>
    );
  }
}

export default AddressDropdown;
